import React, { useEffect } from 'react';
import { useDispatch, shallowEqual, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';

import Button from '@chronos/components/Button';
import LogoutIcon from '@chronos/components/Icons/LogoutIcon';
import { mapState, logout } from '../../slices/appSlice';

import * as S from './styled';

function Page() {
  const { isAuthorized, profile } = useSelector(mapState, shallowEqual);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthorized) {
      navigate('/auth');
    }
  }, [isAuthorized]);

  if (!isAuthorized) {
    return null;
  }

  return (
    <S.Page>
      <S.Header>
        <S.Navigation>
          <Button
            withIcon
            appearance="subtle-link"
            spacing="none"
            onClick={() => {
              navigate('/');
            }}
          >
            Transactions
          </Button>
          {profile.role === 'superAdmin' && (
            <Button
              withIcon
              appearance="subtle-link"
              spacing="none"
              onClick={() => {
                navigate('/stats');
              }}
            >
              Statistic
            </Button>
          )}
        </S.Navigation>
        <S.Profile>
          <S.Username>👤 {profile.username}</S.Username>
          <Button
            withIcon
            appearance="subtle-link"
            spacing="none"
            onClick={() => {
              dispatch(logout());
            }}
          >
            <LogoutIcon size="middle" />
          </Button>
        </S.Profile>
      </S.Header>
      <Outlet />
    </S.Page>
  );
}

Page.propTypes = {};

export default Page;
